<div
  *ngIf="status"
  class="cg-flex-vertical-center"
  [class.cg-font-size-m]="size === 'medium'"
  [class.cg-font-size-ml]="size === 'large'"
>
  <div class="cg-margin-right-sm">
    <cigna-icon
      *ngIf="status === 'APPROVE' || status === 'PARTIAL_APPROVE'"
      [class.cg-icon-sm]="size === 'small'"
      [class.cg-icon-md]="size === 'medium'"
      [class.cg-icon-lg]="size === 'large'"
      class="cg-color-success"
      type="checkmark-circle-outline"
    ></cigna-icon>
    <cigna-icon
      *ngIf="status === 'PEND' || status === 'VOID' || status === 'MIXED'"
      [class.cg-icon-sm]="size === 'small'"
      [class.cg-icon-md]="size === 'medium'"
      [class.cg-icon-lg]="size === 'large'"
      class="cg-color-warn"
      type="exclamation-triangle"
    ></cigna-icon>
    <cigna-icon
      *ngIf="status === 'DENY'"
      [class.cg-icon-sm]="size === 'small'"
      [class.cg-icon-md]="size === 'medium'"
      [class.cg-icon-lg]="size === 'large'"
      class="cg-color-severe-warn"
      type="exclamation-circle"
    ></cigna-icon>
    <cigna-icon
      *ngIf="status === 'INCOMPLETE'"
      [class.cg-icon-sm]="size === 'small'"
      [class.cg-icon-md]="size === 'medium'"
      [class.cg-icon-lg]="size === 'large'"
      class="cg-color-info"
      type="info-circle"
    ></cigna-icon>
  </div>

  {{ PrecertificationStatus[status] }}
</div>
